import React from "react";
import { Card } from "react-bootstrap";
import _ from "lodash";
import SchoolOrCollegeDetails from "./SchoolOrCollegeDetails";
import GraduationDetails from "./GraduationDetails";
import CertificationDetails from "./CertificationDetails";
import { QUALIFICATION_TYPES } from "../../constants/constants";

export const QualificationDetails = ({ qualificationDetails }) => {
  const sortedQualification = _.orderBy(
    qualificationDetails,
    ["qualificationId"],
    ["asc"]
  );

  const getReportByQualification = (qualificationID, qualificationDetails) => {
    switch (qualificationID) {
      case QUALIFICATION_TYPES.CLASSX:
      case QUALIFICATION_TYPES.CLASSXII:
        return (
          <SchoolOrCollegeDetails qualificationDetails={qualificationDetails} />
        );
      case QUALIFICATION_TYPES.GRADUATION:
      case QUALIFICATION_TYPES.POSTGRADUATION:
        return (
          <GraduationDetails qualificationDetails={qualificationDetails} />
        );
      case QUALIFICATION_TYPES.CERTIFICATION:
        return (
          <CertificationDetails qualificationDetails={qualificationDetails} />
        );
      default:
        return "";
    }
  };

  return (
    <div className="container mt-3">
      <Card.Header className="accordian-header">EDUCATION</Card.Header>
      <div className="container mt-3">
        {!!sortedQualification && !!sortedQualification.length ? (
          sortedQualification.map(function (qualification, i) {
            return (
              <div key={i}>
                {getReportByQualification(
                  qualification.qualificationId,
                  qualification
                )}
              </div>
            );
          })
        ) : (
          <p className="text-center">
            {" "}
            Qualification Details are not available
          </p>
        )}
      </div>
    </div>
  );
};

export default QualificationDetails;
